import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { CheckCircle, Mail, ArrowRight } from 'lucide-react';

export const CoachPaymentSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/login');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8 lg:p-10 w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold mb-4">
            <span className="text-gray-900">Game</span>
            <span className="text-green-600">Path</span>
          </h1>
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="text-xl font-bold text-gray-900">Payment Successful</h2>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-xl p-5 mb-6">
          <div className="flex items-start gap-3">
            <Mail className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-semibold text-blue-900 mb-1">Check Your Email</p>
              <p className="text-sm text-blue-800">
                We've sent a verification email to your registered email address.
                Click the link in the email to activate your account.
              </p>
              <p className="text-xs text-blue-600 mt-2">
                Didn't receive it? Check your spam folder.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-6">
          <div className="flex items-center gap-2 text-sm text-green-800">
            <ArrowRight className="w-4 h-4" />
            <span>Once verified, sign in to start building your team</span>
          </div>
        </div>

        <div className="text-center">
          <Link
            to="/login"
            className="inline-block w-full bg-green-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-green-700 transition-colors text-center"
          >
            Go to Sign In
          </Link>
          <p className="text-xs text-gray-500 mt-3">
            Redirecting to sign in in {countdown} seconds...
          </p>
        </div>
      </div>
    </div>
  );
};
